export const getKey = (i: number): string => 'f-' + String(i)
